module.exports = __webpack_public_path__ + "static/media/up-arrow.08bf0173.svg";